import http from "./http-common";
import JWT from "./Jwt";
import Crypto from "./Crypto";
import { getServidor } from "../utils/Utils";

/**
 * @brief Clase de dispositivos.
 * @class DevicesDataService
 */

class DevicesDataService{

    /**
     * Endpoint de Dispositivos
     */

    /**
     * @brief Método que obtiene todos los dispotivos registrados en el sistema
     * @returns {Promise<AxiosResponse<any>>} Lista de dispositivos en formato JSON.
     */
    getAll() {
        return http.get(`${getServidor()}/dispositivos/`);
    }

    /**
     * @brief Método que obtiene todos los dispotivos registrados en el sistema
     * @returns {Promise<AxiosResponse<any>>} Lista de dispositivos en formato JSON, ordenada alfebeticamente.
     */
    getAllOrden() {
        return http.get(`${getServidor()}/dispositivos/ordenAlfabetico`);
    }

    /**
     * @brief Método que crea un dispositivo
     * @param data Datos del dispositivo a crear.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos al servidor.
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP de la creación del dispositivo.
     */
    async create(data, key){
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.post(`${getServidor()}/dispositivos/`, datosEncriptados);
    }
    /**
     * @brief Método que elimina un dispositivo en el sistema
     * @param data Datos con los nuevos valores del dispositivo.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos al servidor.
     * @returns {Promise<AxiosResponse<any>>} Objeto con respuesta de confirmación de eliminar dispositivo
     */
    async delete(data, key){
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.delete(`${getServidor()}/dispositivos/`, { data: datosEncriptados });
    }
    /**
     * @brief Actualiza los datos de un dispositivo existente.
     *
     * @param data Datos con los nuevos valores del dispositivo.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos al servidor.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP de la actualización del dispositivo.
     */
    async update(data, key){
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.put(`${getServidor()}/dispositivos/`, datosEncriptados) 
    }

    /**
     * @brief Verifica si un dispositivo existe en el sistema.
     *
     * @param imei Número IMEI del dispositivo a verificar.
     * @param telefono Número telefónico asociado al dispositivo.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con la verificación de existencia.
     */
    existe(imei, telefono){
        return http.get(`${getServidor()}/dispositivos/existe/`+ JWT.jwtEncode(imei), JWT.jwtEncode(telefono));
    }

    /**
     * @brief Obtiene todos los dispositivos deshabilitados en el sistema.
     *
     * @returns {Promise<AxiosResponse<any>>} Lista de dispositivos deshabilitados en formato JSON.
     */
    getDisabledDevices(){
        return http.get(`${getServidor()}/dispositivos/deshabilitados`);
    }

    /**
     * @brief Cambia el estado del GPS de un dispositivo.
     *
     * @param data Datos que contienen identificador y nuevo estado del dispositivo.
     * @param key Clave utilizada para encriptar los datos antes de enviarlos al servidor.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP del cambio de estado del GPS.
     */
    async toggleGpsStatus(data,key){
        const datosEncriptados = await Crypto.encriptar(data, key);
        return http.put(`${getServidor()}/dispositivos/toggle-status`, datosEncriptados);
    }
}
/**
 * @brief Instancia del servicio de dispositivos.
 * @type {DevicesDataService}
 */
export default new DevicesDataService();